import { MainPageContent } from "@/routes/_components/main-page";
import { DeliveriesListTable } from "./_components/deliveries-list-table";

export function DeliveriesRoute() {
  return (
    <MainPageContent className="grid grid-cols-1 gap-4">
      <DeliveriesListTable />
    </MainPageContent>
  );
}
